module.exports = __webpack_public_path__ + "media/packs/static/fonts/icon/font-d098a017505ac6493ba57020d098165e.woff";